import styled from 'styled-components';
import { Link } from 'react-router-dom';

import colors from '../../../assets/css/colors';

export const IconLinkGroup = styled.div`
	display: flex;
`;

const IconLinkStyled = styled(Link)`
	color: ${colors.nrlDarkGreenHover};
	margin: 0 5px;
`;

export default IconLinkStyled;


// WEBPACK FOOTER //
// ./src/pages/leagues/myLeagues/IconLinkStyled.js